"use client";

import { medimoPublicQC } from "@medimo/core-api/internal/next";
import { RequestResetPasswordDialog, SignInForm } from "@medimo/core-auth/ui";
import { useMicrophoneBannerDismissal } from "@medimo/global-state";
import { NOTIFICATION_BANNER_DISMISSED_SESSION_KEY } from "@medimo/notification";
import { Card, CardContent, CardHeader, CardTitle } from "@medimo/ui";
import { signOut } from "aws-amplify/auth";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useIsClient } from "usehooks-ts";
import { useCreateUserOnDB } from "../_hooks/use-create-user";

export default function SignInPage() {
  const router = useRouter();
  const isClient = useIsClient();
  const {
    isPending,
    error,
    mutateAsync: registerUserOrUpdateOnDB,
  } = useCreateUserOnDB();
  const { mutateAsync: requestPasswordRecovery } = medimoPublicQC.useMutation(
    "post",
    "/v2/auth/password-recovery",
  );

  if (!isClient) return null;

  return (
    <>
      <Card className="mx-3 my-5 w-full max-w-md py-5">
        <CardHeader className="space-y-1">
          <Image
            src="/medimo/logo-with-text.png"
            alt="logo"
            width={300}
            height={100}
            className="mx-auto w-3/4 pb-10"
            priority={false}
          />
          <CardTitle className="text-xl">ログイン</CardTitle>
        </CardHeader>
        <CardContent className="grid gap-4">
          <SignInForm
            isPending={isPending}
            defaultValues={{
              email: "",
              password: "",
            }}
            onSuccessToSignIn={() => {
              registerUserOrUpdateOnDB()
                .then(() => {
                  useMicrophoneBannerDismissal.getState().reset();
                  try {
                    sessionStorage.setItem("showNotificationDialog", "true");
                    // 同じタブでも次回ログインではお知らせバナーを再表示する
                    sessionStorage.removeItem(
                      NOTIFICATION_BANNER_DISMISSED_SESSION_KEY,
                    );
                  } catch (e) {
                    console.error(
                      "セッションストレージへの書き込みに失敗しました:",
                      e,
                    );
                  }

                  router.replace("/");
                })
                .catch(async () => {
                  await signOut().catch(() => undefined);
                });
            }}
            onRequireNewPassword={(result) => {
              router.replace(
                `/auth/set-initial-password?email=${encodeURIComponent(result.email)}`,
              );
            }}
            onRequireTwoFactor={() => {
              router.replace("/auth/two-factor");
            }}
            errorMessage={error?.message}
          />
          <RequestResetPasswordDialog
            logoSrc="/medimo/logo-with-text.png"
            onRequestRecovery={async (email: string) => {
              await requestPasswordRecovery({ body: { email } });
              router.replace(
                `/auth/reset-password?email=${encodeURIComponent(email)}`,
              );
            }}
          />
        </CardContent>
      </Card>
    </>
  );
}
